export default "__VITE_ASSET__Ea4Gh_0d__"